import type { IExtractParams } from "@/routes";
import { apiPathFunc } from "@api/util/apiPathFunc";
import { interactiveExamFinishAttempt } from "@api/courses/exams/interactive/attempts/finish/path";
import { examAttemptQuestions } from "@api/courses/exams/interactive/attempts/questions/path";
import { interactiveExamSubmissions } from "@api/courses/exams/interactive/attempts//submissions/path";
import { latest } from "@api/courses/exams/interactive/attempts/latest/path";

const pathBase = `/courses/:courseId/exams/interactive/:examId/attempts/`;
const pathById = `${pathBase}:attemptId/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;
export type IPathByIdParam = IExtractParams<typeof pathById>;

export const interactiveExamAttempt = {
  post: apiPathFunc(pathBase),
  get: apiPathFunc(pathById),
  interactiveExamFinishAttempt,
  examAttemptQuestions,
  interactiveExamSubmissions,
  latest,
} as const;
